/**
 * Service layer for Token.
 * This service centralizes the state, orchestration, or data access used by its feature area.
 */
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  getAccessToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  getSessionId(): string | null {
    return localStorage.getItem('sessionId');
  }

  setTokens(accessToken: string, refreshToken: string, sessionId: string, expiresIn: string): void {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('sessionId', sessionId);
    localStorage.setItem('expiresIn', expiresIn);
  }

  setAccessToken(accessToken: string): void {
    localStorage.setItem('accessToken', accessToken);
  }

  clearTokens(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('expiresIn');
  }
}
